import type { SortingState } from "@tanstack/react-table";
import { getOnChangingSortFunc } from "../../utils";
import { orderingColumn } from "../Columns/columns";

interface ChargesDataQuery {
  setOrder: (
    value: Record<string, "desc" | "asc"> | Record<string, never>,
  ) => void;
}

interface UsePaywallChargesListProps {
  chargesData: ChargesDataQuery;
}

interface UsePaywallChargesListReturn {
  onChangeSorting: (orders: SortingState) => void;
}

export const usePaywallChargesList = ({
  chargesData,
}: UsePaywallChargesListProps): UsePaywallChargesListReturn => {
  const onChangeSorting = getOnChangingSortFunc({
    dataQuery: chargesData,
    orderingColumn,
  });

  return {
    onChangeSorting,
  };
};
